function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.647059%,67.058825%,0%)",
      fillOpacity: 1
    },
    d: "M 36.128906 33.175781 C 36.132812 34.523438 35.5625 35.8125 34.554688 36.714844 C 33.546875 37.613281 32.199219 38.039062 30.859375 37.878906 C 28.445312 37.523438 26.675781 35.421875 26.734375 32.980469 L 26.734375 4.929688 C 26.675781 2.488281 28.449219 0.386719 30.867188 0.03125 C 32.207031 -0.125 33.550781 0.300781 34.554688 1.199219 C 35.5625 2.097656 36.132812 3.386719 36.128906 4.738281 Z M 36.128906 33.175781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.019608%,45.490196%,0%)",
      fillOpacity: 1
    },
    d: "M 6.570312 28.527344 C 9.164062 28.527344 11.265625 30.628906 11.265625 33.222656 C 11.265625 35.816406 9.164062 37.917969 6.570312 37.917969 C 3.976562 37.917969 1.875 35.816406 1.875 33.222656 C 1.875 30.628906 3.976562 28.527344 6.570312 28.527344 Z M 18.925781 14.289062 C 16.320312 14.433594 14.300781 16.621094 14.359375 19.230469 L 14.359375 31.84375 C 14.359375 35.269531 15.867188 37.347656 18.074219 37.789062 C 19.460938 38.070312 20.898438 37.714844 21.992188 36.816406 C 23.085938 35.921875 23.71875 34.578125 23.714844 33.167969 L 23.714844 19.011719 C 23.714844 17.746094 23.210938 16.535156 22.308594 15.648438 C 21.410156 14.761719 20.191406 14.273438 18.925781 14.289062 Z M 18.925781 14.289062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalyticsIcon);
export default __webpack_public_path__ + "static/media/google-analytics-icon.a3032fb62b8838006ebd99b25038bf37.svg";
export { ForwardRef as ReactComponent };